import { Collection, CollectionItem, Screen } from 'mytours-read-common'
import db from '../db'
import { FavouritedItem } from './types'
import {
	GetCollectionItemsIndexResponseData,
	GetCollectionsShowResponse,
	GetScreensShowResponse,
} from 'mytours-read-api-typescript'

export function collectionSubtypeToItemSubtype(
	subtype: GetCollectionsShowResponse.SubtypeEnum,
): GetCollectionItemsIndexResponseData.ItemSubtypeEnum {
	switch (subtype) {
		case GetCollectionsShowResponse.SubtypeEnum.CollectionList:
			return GetCollectionItemsIndexResponseData.ItemSubtypeEnum.List
		case GetCollectionsShowResponse.SubtypeEnum.CollectionTour:
			return GetCollectionItemsIndexResponseData.ItemSubtypeEnum.Tour
		case GetCollectionsShowResponse.SubtypeEnum.CollectionMenu:
			return GetCollectionItemsIndexResponseData.ItemSubtypeEnum.Menu
		case GetCollectionsShowResponse.SubtypeEnum.CollectionSearch:
			return GetCollectionItemsIndexResponseData.ItemSubtypeEnum.Search
		case GetCollectionsShowResponse.SubtypeEnum.CollectionOrganization:
			return GetCollectionItemsIndexResponseData.ItemSubtypeEnum.Organization
		default:
			throw new Error(`Unknown subtype ${subtype}`)
	}
}

export function screenTypeToItemSubtype(
	screenType: GetScreensShowResponse.ScreenTypeEnum,
): GetCollectionItemsIndexResponseData.ItemSubtypeEnum {
	switch (screenType) {
		case GetScreensShowResponse.ScreenTypeEnum.Ar:
			return GetCollectionItemsIndexResponseData.ItemSubtypeEnum.Ar
		case GetScreensShowResponse.ScreenTypeEnum.Kiosk:
			return GetCollectionItemsIndexResponseData.ItemSubtypeEnum.Kiosk
		case GetScreensShowResponse.ScreenTypeEnum.Panorama:
			return GetCollectionItemsIndexResponseData.ItemSubtypeEnum.Panorama
		case GetScreensShowResponse.ScreenTypeEnum.Story:
			return GetCollectionItemsIndexResponseData.ItemSubtypeEnum.Story
		case GetScreensShowResponse.ScreenTypeEnum.Web:
			return GetCollectionItemsIndexResponseData.ItemSubtypeEnum.Web
		default:
			throw new Error(`Unknown screen type ${screenType}`)
	}
}

export function screenToFavouritedItem(item: Screen): FavouritedItem | undefined {
	if (!item.id || !item.screen_type) {
		return
	}
	const { cover_image, cover_image_grid, title } = item
	const favouritedItem: FavouritedItem = {
		item_id: item.id,
		item_type: GetCollectionItemsIndexResponseData.ItemTypeEnum.Screen,
		item_subtype: screenTypeToItemSubtype(item.screen_type),
		cover_image,
		cover_image_grid,
		title,
	}
	return favouritedItem
}

export function collectionToFavouritedItem(item: Collection): FavouritedItem | undefined {
	if (!item.id || !item.subtype) {
		return
	}
	const { cover_image, cover_image_grid, title } = item
	const favouritedItem: FavouritedItem = {
		item_id: item.id,
		item_type: GetCollectionItemsIndexResponseData.ItemTypeEnum.Collection,
		item_subtype: collectionSubtypeToItemSubtype(item.subtype),
		cover_image,
		cover_image_grid,
		title,
	}
	return favouritedItem
}

export function collectionItemToFavouritedItem(item: CollectionItem): FavouritedItem | undefined {
	if (!item.item_id || !item.item_type || !item.item_subtype) {
		return
	}
	const favouritedItem: FavouritedItem = {
		item_id: item.item_id,
		item_type: item.item_type,
		item_subtype: item.item_subtype,
		cover_image: item.cover_image,
		cover_image_grid: item.cover_image_grid,
		title: item.title,
	}
	return favouritedItem
}

export const addToFavouritedKeys = async (key: string, item: FavouritedItem): Promise<void> => {
	await db.favouritedKeys.put({ key })
	await db.favouritedItems.put({ ...item, key })
}

export const removeFromFavouritedKeys = async (key: string): Promise<void> => {
	await db.favouritedKeys.delete(key)
	await db.favouritedItems.where({ key }).delete()
}
